<template>
  <div class="form-group">
    <label v-if="title && title.trim().length > 0" for="">
      {{ title }} <span class="text-danger">{{ isRequire ? "(*)" : "" }}</span>
    </label>
    <div class="col-12" v-if="!isReadOnly">
      <div class="form-group">
        <div class="btn btn-default btn-file" :class="{ 'border-danger': error }">
          <i class="fas fa-paperclip"></i> Thêm tập tin
          <input type="file" name="attachment" :multiple="isMultiple" @change="onChooseFile" :accept="acceptFile" />
        </div>
        <span class="help-block font-italic ml-2">(Tối đa: {{ maxSize }}MB)</span>
      </div>
    </div>
    <div class="col-12 list-files">
      <div v-if="isMultiple"></div>
      <div v-else>
        <div class="clearfix mb-1" v-if="initialValue && initialValue.length > 0">
          <span class="text-primary">{{ initialValue[0].name || initialValue[0].fileName }} </span>
          <a :href="createTempUrl(initialValue[0])"
            :download="initialValue[0].name || initialValue[0].fileName || 'downloaded-file'" target="_blank"
            @click.prevent="openFile(initialValue[0])">
            <i class="fas fa-download text-primary text-bold ml-2" title="Tải file"></i>
          </a>
          <i v-if="!isReadOnly" class="fas fa-times text-danger text-bold ml-2" @click="onRemoveFile(0)"
            title="Xóa File" style="cursor: pointer"></i>
        </div>
      </div>
    </div>
    <div class="text-danger text-right mb-2" style="margin-top: -13 !important;" v-if="error">
      {{ error }}
    </div>

  </div>
</template>
<script>
import $ from 'jquery'
import { ref, toRefs } from "vue";
import { mapActions } from "vuex";
import config from "@/config/prod.env";
import { header } from '@/helper/header';
export default {
  name: "TheCustomFilePicker",
  props: {
    title: String,
    initialValue: Array,
    error: String,
    isReadOnly: Boolean,
    isRequire: Boolean,
    isMultiple: Boolean,
    acceptFile: String,
  },
  data() {
    return {
      //API_URL: config.API_URL,
      files: [],
      maxSize: 30, // MB
    };
  },
  setup(props) { },
  methods: {
    async createTempUrl(file) {
      if (file.fileId) {

        const response = await fetch(file.downloadLink, {
          method: "GET",
          headers: await header.authHeaderWithToken(),
        });

        if (!response.ok) {
          console.error("Failed to fetch the file:", response.statusText);
          return;
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        return url;
      } else {
        // For local files, create a Blob URL directly
        return URL.createObjectURL(file);
      }
    },

    async openFile(file) {
      const url = await this.createTempUrl(file);
      if (url) {
        window.open(url, "_blank");
      }
    },

    async onChooseFile(e) {
      if (!this.isMultiple) {
        this.files = [];
      }
      // this.files = this.files.concat(e.target.files)
      for (let i = 0; i < e.target.files.length; i++) {
        this.files.push(e.target.files[i]);
      }

      this.emitChange(this.files);
    },

    async onRemoveFile(index) {
      const temp = [];
      for (let i = 0; i < this.files.length; i++) {
        if (index !== i) {
          temp.push(this.files[i]);
        } /* else {
                    if(this.files[i].id.length > 0) {
                        await this.deleteFile(this.files[i].id);
                    }
                }*/
      }
      this.files = temp;

      this.emitChange(this.files);
    },
    emitChange(files) {
      this.$emit("onChange", files);
    },

  },
  mounted() {
    this.files = this.initialValue;
  }
};
</script>
